import GetStarted from './GetStarted';
import SetupSm from './SetupSm';
import Success from './Success';
import Verify from './Verify';

export {
    GetStarted, SetupSm, Success, Verify
}